import { fetchReviewsData } from "@/services/productServices";
import { ThunkResult } from "@/models/common/core/ThunkResult";
import { ReviewsDataFetchedAction } from "@/models/scope/productSheet/reviews/ReviewsDataFetchedAction";
import { REVIEWS_DATA_FETCHED } from "@/redux/reducers/responsive/actionsTypes";
import { ProductReviewList } from "@/models/scope/productSheet/reviews/ProductReviewList";
import { Review } from "@/models/scope/productSheet/reviews/Review";


interface Params {
    productId: string,
    pageIndex: number,
    productReviewsListItems: Review[];
    sortedBy?: string;
}

export const fetchReviewsListData = (data: Params): ThunkResult<ReviewsDataFetchedAction> => (dispatch) =>
    fetchReviewsData(data)
        .then((reviews: ProductReviewList) => {
            dispatch({
                type: REVIEWS_DATA_FETCHED,
                payload: {
                    reviewListStatistics: reviews.reviewListStatistics,
                    items: reviews.items,
                    productReviewsListItems: data.productReviewsListItems,
                    changeFromClient: true,
                    pageIndex: data.pageIndex,
                }
            });
        })
        .catch((error) => {
            console.error(error);
        });
